// extracted by mini-css-extract-plugin
module.exports = {"ComparisonCards":"ComparisonCards_ComparisonCards__w8rhd","comparisonCardsWrapper":"ComparisonCards_comparisonCardsWrapper__k_ftt","Heading":"ComparisonCards_Heading__y3bis"};